import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  listArticles, 
  createArticle, 
  updateArticle, 
  updateArticleStatus 
} from '../../api/helpCenterArticle';
import { message } from 'antd';

// 查询帮助中心文章列表
export const fetchHelpCenterArticles = createAsyncThunk(
  'helpCenterArticle/fetchList',
  async (params = { page: 1, pageSize: 10 }, { rejectWithValue }) => {
    try {
      const response = await listArticles(params);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '获取列表失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 创建帮助中心文章
export const createHelpCenterArticle = createAsyncThunk(
  'helpCenterArticle/create',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await createArticle(data);
      message.success('创建成功');
      // 创建成功后重新获取列表
      dispatch(fetchHelpCenterArticles());
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '创建失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 更新帮助中心文章
export const updateHelpCenterArticle = createAsyncThunk(
  'helpCenterArticle/update',
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateArticle(id, data);
      message.success('更新成功');
      // 更新成功后重新获取列表
      dispatch(fetchHelpCenterArticles());
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '更新失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 更新帮助中心文章状态
export const updateHelpCenterArticleStatus = createAsyncThunk(
  'helpCenterArticle/updateStatus',
  async ({ id, status }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateArticleStatus(id, status);
      message.success('状态更新成功');
      // 更新成功后重新获取列表
      dispatch(fetchHelpCenterArticles());
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '状态更新失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const helpCenterArticleSlice = createSlice({
  name: 'helpCenterArticle',
  initialState: {
    articles: [],
    total: 0,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    currentArticle: null,
    error: null
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentArticle: (state, action) => {
      state.currentArticle = action.payload;
    }
  },
  extraReducers: (builder) => {
    // 查询列表
    builder.addCase(fetchHelpCenterArticles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHelpCenterArticles.fulfilled, (state, action) => {
      state.loading = false;
      state.articles = action.payload.records || [];
      state.total = action.payload.total || 0;
    });
    builder.addCase(fetchHelpCenterArticles.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 创建
    builder.addCase(createHelpCenterArticle.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createHelpCenterArticle.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createHelpCenterArticle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 更新
    builder.addCase(updateHelpCenterArticle.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateHelpCenterArticle.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHelpCenterArticle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 更新状态
    builder.addCase(updateHelpCenterArticleStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateHelpCenterArticleStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHelpCenterArticleStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

export const { setPage, setPageSize, setCurrentArticle } = helpCenterArticleSlice.actions;
export default helpCenterArticleSlice.reducer;

